import React, { useEffect, useState } from 'react';
import TextWinds from '../common/TextWinds';
import SimpleDialog from '../layout/SimpleDialog';
import DeliveryInfoList from './DeliveryInfoList';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import {
  getDeliveryInfoDefault,
  getDeliveryInfoList,
  selectDeliveryInfo,
} from '../../store/features/orderInfoSlice';
import DeliveryInfoCard from './DeliveryInfoCard';
import DeliveryInfoChange from './DeliveryInfoChange';
import HFinput from '../common/input/HFinput';
import { UseFormRegister } from 'react-hook-form';
import { PurchaseRequestDto } from '../../store/features/purchaseSlice';

const DeliveryInfo = ({
  register,
}: {
  register: UseFormRegister<PurchaseRequestDto>;
}) => {
  const dispatch = useAppDispatch();
  const deliveryInfo = useAppSelector(selectDeliveryInfo);

  const [state, setState] = useState<'none' | 'list' | 'form'>('none');
  useEffect(() => {
    dispatch(getDeliveryInfoList({ url: '', params: {} }));
    dispatch(getDeliveryInfoDefault({ url: '', params: {} }));
  }, []);

  const openDialog = () => {
    setState('list');
  };
  return (
    <div className="mt-4 rounded-md bg-white px-[20px] py-[14px]">
      <TextWinds type="title_h4">배송지 정보</TextWinds>
      <div className="mt-4 text-sm">배송지 목록</div>
      {/* 선택된 배송지. 없다면 기본배송지 */}
      <DeliveryInfoCard
        deliveryInfo={deliveryInfo}
        onClick={openDialog}
        setState={setState}
      />

      <SimpleDialog
        open={state !== 'none'}
        title="배송지 정보"
        handleClose={() => setState('none')}
        onConfirm={() => setState('none')}
      >
        {state === 'form' ? (
          <DeliveryInfoChange setState={setState} />
        ) : (
          <DeliveryInfoList setState={setState} />
        )}
      </SimpleDialog>
      <div className="mt-4">
        <HFinput
          label="배송 메세지"
          placeholder="배송 메세지를 입력해주세요."
          register={register('message')}
        />
      </div>
    </div>
  );
};

export default DeliveryInfo;
